import React, {useState} from 'react';
import {Form} from 'react-final-form';
import {SelectInput, useRefresh} from 'react-admin';
import BulkEditOrderSubmitButton from './BulkEditOrderSubmitButton';
import StatusChoiceText from './StatusChoiceText';
import {ORDER_STATUS_MANUAL} from '../global/orderStatus';

// The value a select's change event carries, or the fallback when it has none
const selectedValue = (e, fallback) => {
    const val = e?.target?.value;
    return (val !== undefined && val !== null && val !== '') ? val : fallback;
};

/**
 * The Orders list's bulk actions on the ticked orders: set the Billed State,
 * or set the Order Status (parrot-media/portal/main#322) to any status staff
 * set by hand.
 *
 * @param props
 * @returns {JSX.Element}
 */
const OrderBulkActions = props => {

    const refresh = useRefresh();

    const [editOption, setEditOption] = useState(null);
    const [selectedBilled, setSelectedBilled] = useState(true);
    const [selectedStatus, setSelectedStatus] = useState(null);

    const handleBulkEditSubmit = (e) => {
        e.preventDefault();
    };

    const handleUpdateSuccess = () => {
        setTimeout(function () {
            refresh();
        }, 1000);
    };

    return (
        <>
            <Form
                onSubmit={handleBulkEditSubmit}
                render={({handleSubmit}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <span className="input-inline input-180 input-bulk-edit">
                                <SelectInput
                                    key="bulk_edit_option" source="bulk_edit_option" label="Select value to edit:"
                                    choices={[
                                        {id: 'bulk_edit_option_billed', name: 'Billed State'},
                                        {id: 'bulk_edit_option_status', name: 'Order Status'}
                                    ]}
                                    allowEmpty={true}
                                    onChange={(e) => setEditOption(selectedValue(e, null))}
                                />
                            </span>
                            <span
                                className={(editOption === 'bulk_edit_option_billed') ? 'input-inline input-180 input-bulk-edit' : 'input-hidden'}>
                                <SelectInput
                                    key="bulk_edit_billed" source="bulk_edit_billed" label="Select Billed State:"
                                    choices={[
                                        {id: true, name: 'Billed'},
                                        {id: false, name: 'Not Billed'},
                                    ]}
                                    defaultValue={true}
                                    allowEmpty={false}
                                    onChange={(e) => setSelectedBilled(selectedValue(e, false))}
                                />
                            </span>
                            <span
                                className={(editOption === 'bulk_edit_option_status') ? 'input-inline input-180 input-bulk-edit' : 'input-hidden'}>
                                <SelectInput
                                    key="bulk_edit_status" source="bulk_edit_status" label="Select Order Status:"
                                    choices={ORDER_STATUS_MANUAL}
                                    optionText={<StatusChoiceText/>}
                                    translateChoice={false}
                                    allowEmpty={false}
                                    onChange={(e) => setSelectedStatus(selectedValue(e, null))}
                                />
                            </span>
                            <BulkEditOrderSubmitButton
                                editOption={editOption}
                                selectedIds={props.selectedIds}
                                selectedBilled={selectedBilled}
                                selectedStatus={selectedStatus}
                                onSuccess={() => handleUpdateSuccess()}
                                {...props}
                            />
                        </form>
                    )
                }}
            >
            </Form>
        </>
    );
};

export default OrderBulkActions;
